import React from 'react';
import style from '../css/Journy.module.css';
import { ArrowUpRight } from 'lucide-react';
import image from '../assets/images/IMG-20250826-WA0043.jpg';
import image1 from '../assets/images/IMG-20250826-WA0043.jpg';
import image2 from '../assets/images/IMG-20250826-WA0040.jpg';
import image3 from '../assets/images/IMG-20250826-WA0039.jpg';

function Journy() {
	return (
		<div className={style.journeyContainer}>
			<div className={style.leftSection}>
				<div className={style.imageStack}>
					<img src={image} alt="Plane" className={style.bgImage} />
					<img src={image3} alt="Sail" className={style.overlayImageTop} />
					<img src={image2} alt="Pool" className={style.overlayImageBottom} />
				</div>
				<div className={style.questionBox}>
					<p>
						Have a<br />
						Question?
					</p>
					<div className={style.avatarContainer}>
						<img src={image1} alt="Avatar" className={style.avatar} />
						<div className={style.icon}>
							<ArrowUpRight size={16} />
						</div>
					</div>
				</div>
			</div>

			<div className={style.rightSection}>
				<div className={style.card}>
					<h2>
						Your Journey
						<br />
						Awaits
					</h2>
					<p>
						Let us craft an extraordinary travel
						<br />
						experience tailored just for you.
					</p>
					<button className={style.startButton}>
						Get Started <ArrowUpRight size={16} />
					</button>
				</div>
			</div>
		</div>
	);
}

export default Journy;
